import React, { useContext } from "react";
import { Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { ContextData } from '../../../../../context/Context';
import { toast } from "react-toastify";
import { Getrequest } from "../../../../../context/AxiosRequest";
import ApplyingType from "./AppyingType";
import Header from "./Header";



function ProcessHeader() {



  const Navigate = useNavigate();
  const location = useLocation();
  const {setaccesstoken,accesstoken,setUserTokens} = useContext(ContextData)

  // Format date and time
  const now = new Date();
  const formattedDate = now.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
  const formattedTime = now.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  // Navigation handlers
  const handleNextPage = () => {
    Navigate(
      location.pathname === "/dashboard/report_statistics"
        ? "/dashboard/statistics"
        : "/dashboard/report_statistics"
    );
  };

  const handleNextPageToLogs = () => Navigate("/dashboard/logs");
  const handleNextPageToSettings = () => Navigate("/application/home");

  // Check if active path
  const isActive = (path) =>  location.pathname === path || location.pathname === "/dashboard/report_statistics";
  
  // HandleLogout





  return (
    <div
      className={`flex header-process-content shadow-lg  ${
        isActive("/dashboard/statistics") ? "text-white bg-blue-900" : "bg-white"
      }`}
    >
    {/* Logo Section */}

      <Header/>



    </div>
  );
}

export default ProcessHeader;
